import _noop from 'lodash/noop';
import _map from 'lodash/map';

import { maybePushEcommerceToDatalayer, setAnalyticsContext } from 'utils/ecommerce-analytics';
import { cartItemContext, cartItemToGTMCartItem } from './internal-gtm-tracker/helpers/internal-gtm-converters';
import { GA4_EVENTS } from './internal-gtm-tracker/internal-gtm-tracker.types';
import { EventTracker } from '../events';

export function createDispensaryGTMTracker(): EventTracker {
  // this is for the dispensary's GTM or GAv4 tracker, not our internal one
  // the actual existing tracker is still in utils/ecommerce-analytics using the `maybePushEcommerceToDatalayer` function as the entrypoint
  // this is the start of the refactor to get that into this analytics system instead
  // move more parts into here every time you read this

  return {
    onContextChange: (updates, newContext) => {
      setAnalyticsContext(newContext);
    },

    cartViewed: (payload, context) => {
      const items = _map(payload.products, (item) => ({
        ...cartItemContext(
          context,
          {
            // in this usage, this cache thing isn't used, but we still need to send it
            ...context,
            activePathHasChanged: false,
            activeMenuVariant: context.activeMenuVariant ?? '',
          },
          payload
        ),
        ...cartItemToGTMCartItem(item),
      }));

      maybePushEcommerceToDatalayer({
        event: GA4_EVENTS.viewCart,
        ecommerce: {
          items,
        },
      });
    },

    accountLogin: _noop,
    addedProductToCart: _noop,
    buyItAgainImpression: _noop,
    buyItAgainViewAllClicked: _noop,
    loyaltySignup: _noop,
    placedOrder: _noop,
    removedProductFromCart: _noop,
    searchedForProduct: _noop,
    searchResults: _noop,
    checkoutStarted: _noop,
    viewedCheckout: _noop,
    checkoutSession: _noop,
    viewedProduct: _noop,
    productClicked: _noop,
    imageBannerClicked: _noop,

    // DutchiePay Enrollment
    paymentsError: _noop,
    dutchiePayEnrollmentButtonClicked: _noop,
    dutchiePayCTAButtonClicked: _noop,
    dutchiePayEnrollmentStep: _noop,
    dutchiePayEnrollmentStepCancelled: _noop,
    dutchiePayPlaidOnEvent: _noop,
    dutchiePayPlaidOnLoad: _noop,
    dutchiePayPlaidOnSuccess: _noop,
    dutchiePayPlaidOnExit: _noop,
    dutchiePayAeroSyncOnEvent: _noop,
    dutchiePayPreAuthEvent: _noop,
    dutchiePayAeroSyncOnLoad: _noop,
    dutchiePayAeroSyncOnClose: _noop,
    dutchiePayAeroSyncOnSuccess: _noop,
    dutchiePayAeroSyncOnError: _noop,
    // DuthchiePay Instore
    dutchiePayInstoreAccountLinkViewed: _noop,
    dutchiePayInstoreLoginViewed: _noop,
    dutchiePayInstoreCartViewed: _noop,
    dutchiePayInstoreCartApprovalClicked: _noop,
    dutchiePayInstoreCartApprovalSucceeded: _noop,
    dutchiePayInstoreCartApprovalFailed: _noop,
    sponsoredProductImpression: _noop,
    sponsoredProductClicked: _noop,
    sponsoredBannerImpression: _noop,
    sponsoredBannerClicked: _noop,
    privacyPreferenceUpdated: _noop,
    gaGTMClickEvent: _noop,
    dispensaryClicked: _noop,
    dutchiePayKioskQRCodeModalViewed: _noop,
    loginNudge: _noop,
    roundupForCharityViewed: _noop,
    roundupForCharityToggled: _noop,
    walletPass: _noop,
  };
}
